import { css } from 'lit';
export default css `
  .continue-button-container {
    width: 100%;
  }
`;
//# sourceMappingURL=styles.js.map